(function() {
	'use strict';

	angular.module('qbePortal').controller('QBConfirmDialog', QBConfirmDialog);

	QBConfirmDialog.$inject = [
		'$scope',
		'ngDialog',
		'gtmService',
		'labelService',
		'$state',
		'userInputRepository',
		'MODULE_INFO',
		'$sce',
		'$http',
		'storage',
		'Util',
		'$sanitize'
	];

	function QBConfirmDialog(
		$scope,
		ngDialog,
		gtmService,
		labelService,
		$state,
		userInputRepository,
		MODULE_INFO,
		$sce,
		$http,
		storage,
		util,
		$sanitize
	) {
		var vm = this;
		vm.formData = {};

		$scope.$root.$on('open-confirmation-dialog', openDialog);

		function openDialog() {
			getFormName();

			gtmService.trackCTPEvent('VirtualPageview', $state.current, null);

			ngDialog
				.openConfirm({
					template: '../ngviews/directives/qbConfirmDialog.html',
					className: 'ngdialog-theme-default',
					appendClassName: 'ngdialog--confirm',
					scope: $scope,
					closeByDocument: false,
					closeByEscape: false,
					showClose: false,
					disableAnimation: true
				})
				.then(
					function(value) {
						callSaveData(value);
					},
					function(reason) {
						gtmService.trackCTPEvent(
							'gaClick',
							$state.current,
							reason
						);
						$scope.$root.$broadcast('loading-animation-end');
						$scope.$root.$broadcast('reload-recaptcha');
					}
				);
		}

		function callSaveData(event) {
			var req = {
				method: 'POST',
				url: '/api/ctpswitch/savedata',
				data: vm.formData
			};

			$http(req).then(
				function() {
					vm.incentiveDetails.event = event;
					gtmService.trackCTPEvent(
						'gaFormSubmission',
						$state.current,
						vm.incentiveDetails
					);
					storage.clear();
					var sessionProtPath = labelService.getLabelFor(
						'redirectURL'
					);
					window.location.href = util.linkBuilder(sessionProtPath);
				},
				function(err) {
					storage.clear();
					$state.go('error');
				}
			);
		}

		function getFormName() {
			vm.formName = MODULE_INFO.mainFormName;

			switch (vm.formName) {
				case 'ctpForm': {
					vm.formData = userInputRepository.get();

					delete vm.formData.email;
					delete vm.formData.ctpForm.expiryDate;
					delete vm.formData.ctpForm.formConsent.expiryDate;
					delete vm.formData.ctpForm.contactDetails.expiryDate;

					angular.forEach(vm.formData.ctpForm, function(value, key) {
						vm.formData.ctpForm[key] = sanitizeForm(
							vm.formData.ctpForm[key]
						);
					});

					if (
						angular.isDefined(
							vm.formData.ctpForm.incentiveDetails.paymentNumber
						)
					) {
						if (
							vm.formData.ctpForm.incentiveDetails.directDebit ===
							'true'
						)
							vm.formData.ctpForm.incentiveDetails.paymentNumber =
								'';
					} else {
						vm.formData.ctpForm.incentiveDetails.paymentNumber = '';
					}

					vm.incentiveDetails = vm.formData.ctpForm.incentiveDetails;

					if (
						!angular.isDefined(
							vm.formData.ctpForm.contactDetails.surName
						)
					) {		
						vm.formData.ctpForm.contactDetails.surName = '';				
					}
					
					vm.contactDetails = vm.formData.ctpForm.contactDetails;
				}
			}
		}

		function sanitizeForm(object) {
			angular.forEach(object, function(value, key) {
				object[key] = $sanitize(value);
			});
			return object;
		}

		vm.getLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		vm.getSectionLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getSectionLabelFor(fieldName));
		};

		vm.getSectionDescriptionFor = function(fieldName) {
			return $sce.trustAsHtml(
				labelService.getSectionDescriptionFor(fieldName)
			);
		};
	}

	angular.module('qbePortal').directive('qbConfirmDialog', function() {
		return {
			restrict: 'E',
			controller: 'QBConfirmDialog',
			controllerAs: 'vm',
			scope: {},
			transclude: true,
			link: function($scope, element, attrs) {}
		};
	});
})();
